import { Action, combineReducers } from "@reduxjs/toolkit";

import {
	customerTariffPlans,
	settingsFinancesCustomerTariffPlansAction,
	StateCustomerTariffPlans,
} from "./CustomerTariffPlans";
import { SettingsFinances } from "./interface";

export { SettingsFinances };

export type State = {
	customerTariffPlans: StateCustomerTariffPlans;
};

export type Actions = {
	customerTariffPlans: typeof settingsFinancesCustomerTariffPlansAction;
};

export const settingsFinancesReducer = combineReducers<State, Action<Actions>>({
	customerTariffPlans,
});

export const settingsFinancesAction: Actions = {
	customerTariffPlans: settingsFinancesCustomerTariffPlansAction,
};

export default settingsFinancesReducer;
